import React from 'react';
import PropTypes from 'prop-types';
import { MdDelete } from 'react-icons/md';

import { Icon } from './styles';
import ds from '../../../utils/designSystem';

export default function DeleteButton(props) {
  return (
    <Icon data-testid="delete-button" onClick={props.onClick} type="button">
      <MdDelete color={ds.colors.magicPotion} size={20} />
    </Icon>
  );
}

DeleteButton.propTypes = {
  onClick: PropTypes.func
};
